/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlAccessTokenResponse
 */
export interface ControlAccessTokenResponse {
    /**
     * 
     * @type {string}
     * @memberof ControlAccessTokenResponse
     */
    access_token?: string;
}

/**
 * Check if a given object implements the ControlAccessTokenResponse interface.
 */
export function instanceOfControlAccessTokenResponse(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ControlAccessTokenResponseFromJSON(json: any): ControlAccessTokenResponse {
    return ControlAccessTokenResponseFromJSONTyped(json, false);
}

export function ControlAccessTokenResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlAccessTokenResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'access_token': !exists(json, 'access_token') ? undefined : json['access_token'],
    };
}

export function ControlAccessTokenResponseToJSON(value?: ControlAccessTokenResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'access_token': value.access_token,
    };
}

